import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    truckNumber: Yup.string().required('Număr înmatriculare este un câmp obligatoriu.'),
    phoneNumber: Yup.string()
      .transform(v => (typeof v === 'string' ? v.trim() : v))
      .matches(/^07\d{8}$/, 'Număr telefon trebuie să înceapă cu 07 și să aibă exact 10 cifre.')
      .required('Număr telefon este un câmp obligatoriu.')
  })

export const initialValues = {
  truckNumber: null,
  phoneNumber: null
}

export const isEmpty = value => value === null || value.length === 0
